import { styled } from '../../../core/theme/styled';

export const AccountInfo = styled.div`
  font-size: ${(props) => props.theme.sizes.small};
  margin-top: ${(props) => props.theme.sizes.xxxsmall};
  color: ${(props) => props.theme.configuration.primaryTextColor};
  &:first-child {
    margin-top: 0;
    font-size: ${(props) => props.theme.sizes.normal};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const RadioWrapper = styled.div`
  margin-top: ${(props) => props.theme.sizes.xxxsmall};
`;

export const ItemContainer = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  text-align: left;
  font-size: ${(props) => props.theme.sizes.normal};
  font-family: ${(props) => props.theme.font.face};
  padding: ${(props) => props.theme.sizes.small} ${(props) => props.theme.sizes.normal};
  margin-bottom: ${(props) => props.theme.sizes.normal};
  border-radius: ${(props) => props.theme.roundedCorners.xsmall};
  line-height: 1.5;
  border: 1px solid
    ${(props) =>
      props.selected
        ? props.theme.configuration.primaryColor
        : props.theme.configuration.strokeColor};
`;

export const Items = styled.label`
  display: flex;
  width: 100%;
  flex-direction: column;
  cursor: pointer;
`;
